import {environment} from '../../environments/environment';

declare var globalConfigBackendUrl: string;
declare var globalConfigViewMode: string;
const localhostProject = 'localhost:8080/cobidb-service';
const secureEndpoint = 'training';

const url = environment.production ? globalConfigBackendUrl : 'http://' + localhostProject;

export const viewMode: string = globalConfigViewMode;

/* URL API */
export const apiUrl = url + '/api/';

/* URL AUTHENTICATION */
export const authUrl = url + '/oauth/token';

/* URL PROJECT */
export const globalUrlDev = url + '/' + secureEndpoint + '/';

/* URL NOT SECURED */
export const urlDev = url;

